module.exports = __webpack_public_path__ + "static/media/retificadora.95216213.png";